import React, { useContext, useEffect } from 'react'
import SlotForm from '../BoxPage/SlotForm'
import dayjs from 'dayjs'
import { put } from '../../Common/api'
import GlobalContext from '../GlobalContext'

export default function AdminSlotForm ({ slot, form, setLoading }) {
  const { notificationApi } = useContext(GlobalContext)

  useEffect(() => {
    const json = {
      ...slot,
      range: [dayjs(slot.begin_date), dayjs(slot.end_date)],
      appointment_date: dayjs(slot.appointment_date),
      start: dayjs(slot.start),
      created_at: dayjs(slot.created_at),
      phone: `+${slot.phone}`,
      interphone: slot.box?.interphone,
      box_data: `${slot.box?.name} - ${slot.box?.zip_code}`,
      postal_place_id: slot.postal_place_id
    }
    form.setFieldsValue(json)
  }, [slot])

  const onFinish = (values) => {
    values = { ...values, phone: values.phone.slice(1) }
    saveSlot(values)
  }

  const saveSlot = (params) => {
    params = { ...params, begin_date: params.range[0], end_date: params.range[1] }
    setLoading(true)
    put({
      url: `admin/slots/${slot.id}`,
      params,
      notification: { api: notificationApi, state: 'update' },
      onSuccess: () => {
        setLoading(false)
      },
      onFailure: (errors) => {
        setLoading(false)
        form.setFields(
          Object.keys(errors).map((key) => ({
            name: key,
            errors: errors[key]
          }))
        )
      }
    })
  }

  return (
    <div style={{ position: 'relative', display: 'flex' }}>
      <SlotForm form={form} edit={true} onFinish={onFinish} disabled={slot.is_cancel}
        specialist={slot.specialist} postalPlace={slot.postal_place} />
    </div >
  )
}
